<script>
export default {
	name: 'PromoItem',

	props: [
		'data',
	],
}
</script>

<template>
	<div
		class="product-grid__promo"
		:style="{
			gridArea: `${data.columnSpan} / ${data.columnSpan}`,
			backgroundColor: data.bgColor,
		}">
		<div
			:class="[
				'block-container',
				data.horizontal,
				data.vertical,
			]">
				<a
					:class="[
						'block-content',
						data.textAlign,
					]"
					:href="data.linkUrl"
					:style="{ color: data.textColor }">
					<img
						v-if="data.image"
						class="collection__item-promo"
						:src="$screen.large_up ? data.imageDesktop || data.image : data.image"
						:style="{ objectFit: data.bgSize }" />
					<div v-html="data.title"></div>
					<div v-html="data.text"></div>
					<span
						v-if="data.linkText && data.buttonType.includes('link')"
						:class="[data.buttonType, { 'link-bottom': data.isLinkBottom }]"
						v-text="data.linkText"></span>
					<button
						v-if="data.linkText && !data.buttonType.includes('link')"
						:class="[
							data.buttonType,
							{ 'btn-black': data.textColor === 'black' },
							{ 'btn-white': data.textColor === 'white' },
							{ 'with-arrow': data.isButtonArrow },
							{ 'link-bottom': data.isLinkBottom },
						]"
						v-text="data.linkText"></button>
				</a>
		</div>
	</div>
</template>
